import { ApiCredentialScope } from '@dss-libs/portal/type/portal-types';

/** Returns the i18n key for a scope, e.g. ordersRead → SETTINGS.API_SETTINGS.SCOPE.ORDERS_READ */
export function getApiScopeLabelKey(scope: ApiCredentialScope): string {
  const key = scope.replace(/([A-Z])/g, '_$1').toUpperCase();
  return `SETTINGS.API_SETTINGS.SCOPE.${key}`;
}
